import React from 'react';
import ResultPageModal from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function MonopattiniModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  type,
  processingQuote,
}) {
  return (
    <ResultPageModal
      type={type}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
    />
  );
}

export default MonopattiniModal;
